import React, { useEffect } from "react";
import { dateCalculation } from "../../../utils";
import './styles.css';
import arrow from "../../../../src/images/arrow.svg";

const TopPerforming = ({fetchTopRoutes = () => {}, getTopRoutes = {}, allRoutesInfo = {}, selectedDuration}) => {
    useEffect(() => {
    const date = dateCalculation(selectedDuration);
    const {startDate , endDate} = date;
    const data = {
        "from_time": startDate,
        "to_time": endDate
      }
      fetchTopRoutes(data);
    }, []);

      function hexToRgb(dealType ) {
        const dealTypeToColor = {
            'EARLY_BIRD': '#27AE5F',
            'LAST_MINUTE': '#FED533',
            'SEAT_LEVEL': '#58CCDE',
            'FLAT_DEAL': '#B3325D',
            'NEW_USER': '#EB5757',
          };
        
        const hex = dealTypeToColor[dealType] || '#CCCCCC';

        const bigint = parseInt(hex.replace(/^#/, ''), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        return `${r}, ${g}, ${b}`;
      }
      
      const transformLabel = (label) => {
        let data = label
          .toLowerCase()
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      
          if(data === 'Flat Deal') {
            data = 'Custom Deal';
          }  
          data += " tickets";
          return data;
      };
    return (Object.keys(getTopRoutes).length > 0 && <>
        {(getTopRoutes["route_wise_deals"]).length>0 && <div className="topRoutesText">Top performing routes & deals</div>}
        <div className="outerContainer">
        {getTopRoutes["route_wise_deals"].map(item => ({
                ...item,
                deals: item.deals.sort((a, b) => b.deal_count - a.deal_count)
        })).map((elem, index) => (
                <div className="routeContainer" key={index}>
                    <div className="routeText">{`${elem.src_name}`}
                    <img src={arrow} alt="arrow" className="arrow"/>
                     {`${elem.dest_name}`}</div>
                    <div className="innerContainer">
                        {elem['deals'].map((dealElem, dealIndex) => (
                            <span style={{backgroundColor: `rgba(${hexToRgb(dealElem.deal_type)}, 0.2)`, color: `rgba(${hexToRgb(dealElem.deal_type)})`, cursor: 'pointer'}} className="rotuteType" key={dealIndex}>
                                {dealElem.deal_count} {`${transformLabel(dealElem.deal_type)}`}
                            </span>
                        ))}
                    </div>
                </div>
            ))}
        </div>
        </>

    )
}

export default TopPerforming;